module.exports = __webpack_public_path__ + "img/active.f6d2a97f.svg";